import React from "react";
import NewExpense from "./components/NewExpense/NewExpense";
//import ExpenseItem from "./components/ExpenseItem";
import Expenses from "./components/Expenses/Expenses";
const App = () => {
  const expenses = [
    {
      id: "e1 ",
      title: "Toilt Paper",
      amount: 94.12,
      date: new Date(2020, 7, 14),
    },
    {
      id: "e2 ",
      title: "New TV",
      amount: 799.49,
      date: new Date(2020, 2, 12),
    },
    {
      id: "e3 ",
      title: "Car Insurance",
      amount: 294.67,
      date: new Date(2021, 2, 28),
    },
    {
      id: "e4 ",
      title: "New Desk (wooden)",
      amount: 450,
      date: new Date(2021, 5, 12),
    },
  ];

  const addExpenseHandler = (expense) => {
    console.log("In App.js");
    console.log(expenses);
  };
  return (
    <div>
      <NewExpense onAddExpense={addExpenseHandler} />
      <Expenses items={expenses} />
    </div>
  );
};

export default App;
